<template>
    <b-card-body class="accordionContent pt-3">
        <div class="card activeCard">			
            <div class="container-mars mt-3">
                <div class="card-container">
                    <div class="card-body">
                        <b-row>
                            <b-col lg="3" md="3" sm="12">
                                <MdEdit 
                                    v-bind:Label="$t('Shared.Days')"
                                    v-bind:Name="`Days_${index}`"
                                    v-bind:TypeProp="'number'"                      
                                    v-bind:Min="'1'"
                                    v-bind:Max="'1000'"
                                    v-bind:isRequired="true"
                                    v-bind:isValid="isDayValid"
                                    v-model.number="value.day"
                                    v-on:blur="OnBlurDay($event)"
                                    v-on:change="onChangeDay($event)"
                                    v-bind:isReadOnly="frecuencyMode === 'STAT'"
                                />   
                            </b-col> 
                            <b-col lg="3" md="3" sm="12">
                                <MdEdit 
                                    v-bind:Label="`${$t('Shared.Dosage')} ${unitOfMeasure}`"
                                    v-bind:Name="`Dosage_${index}`"
                                    v-bind:TypeProp="'number'"                      
                                    v-bind:Min="'1'"
                                    v-bind:Max="'1000'"
                                    v-bind:isRequired="true"
                                    v-bind:isValid="isDosageValid"
                                    v-model.number="value.doseQty"
                                    v-on:change="onChangeDosage($event)"
                                />   
                            </b-col> 
                            <b-col lg="2" md="2" sm="12">
                                <MdEdit 
                                    v-bind:Label="`${$t('Shared.DailyAmount')} ${unitOfMeasure}`"
                                    v-bind:Name="`DailyAmount_${index}`"
                                    v-bind:TypeProp="'number'"                      
                                    v-bind:Min="'1'"
                                    v-bind:Max="'1000'"
                                    v-bind:isRequired="true"
                                    v-bind:isValid="isDailyAmountValid"
                                    v-on:change="onChangeDailyAmount($event)"               
                                    v-model.number="value.qtytoTake"
                                />  
                            </b-col>  
                            <b-col lg="2" md="2" sm="12">
                                <MdEdit 
                                    v-bind:Label="$t('Shared.TotalQty')"
                                    v-bind:Name="`totalqty_${index}`"
                                    v-bind:TypeProp="'number'"                      
                                    v-bind:Min="'1'"
                                    v-bind:Max="'1000'"
                                    v-model.number="value.quantityOrdered"
                                    v-bind:isReadOnly="true"
                                />   
                            </b-col>
                            <b-col lg="2" md="2" sm="12">
                                <MdEdit 
                                    v-bind:Label="$t('DrugSetupProtocol.TitrationOrder')"
                                    v-bind:Name="`TitrationOrder_${index}`"
                                    v-bind:TypeProp="'number'"                      
                                    v-bind:Min="'1'"
                                    v-bind:Max="'1000'"
                                    v-bind:isRequired="true"
                                    v-bind:isValid="isTitrationOrderValid"
                                    v-model.number="value.titrationOrder"
                                />  
                            </b-col>
                        </b-row>

                        <b-row>
                            <b-col lg="3" md="3" sm="12">
                                <MdLookup
                                    v-bind:ModelCode="value.frequency"
                                    v-bind:ModelDescription="value.frequencyDescription"
                                    v-bind:Label="$t('Shared.Frequency')"
                                    v-bind:RefCode="`Frequency_${index}`"  
                                    v-bind:AuxFields="FrequencyAuxFields"                     
                                    v-bind:Api="'DrugFrequencyHeaders?AdministrationFrequencies=true'"
                                    v-bind:FieldCode="'code'"  
                                    v-bind:isValid="isFrequencyValid"
                                    v-bind:isRequired="true"                         
                                    v-bind:FieldDescription="'description'"
                                    :InvalidFeedback="TextFrequency"    
                                    :SearchTitle="$t('Shared.Frequency')"
                                    :GetValues="onCodeConditionOk"                     
                                    :SearchFieldCode="'Code'"
                                    v-bind:Fields="BaseFields"
                                />
                            </b-col>
                            <b-col lg="3" md="3" sm="12">
                                <MdButton
                                    v-bind:Label="$t('Medication.Dosage-Time')"
                                    v-bind:Name="`btn_dosagetime_${index}`"
                                    v-bind:ClassProp="'secondary mt-3 btn-login'"
                                    v-on:click="OpenDosageTime"
                                    v-bind:isReadOnly="(value.frequency && (value.doseQty || value.qtytoTake) && frecuencyMode !== 'STAT' && frecuencyMode !== 'PRN') ? false : true"
                                />                    
                            </b-col> 
                        </b-row>

                        <MdTitle v-bind:Text="$t('Shared.Sig')" v-bind:isSubtitle="true" v-bind:Name="'T_TitleSearch'"/>
                        <b-row>
                            <b-col lg="3" md="3" sm="12">
                                <MdSelect
                                    v-bind:Label="$tc('Shared.ActionsTxt')"
                                    v-bind:Options="ActionList"
                                    v-bind:FieldDescription="'description'"
                                    v-bind:FieldCode="'code'"
                                    v-bind:Model="ModelAction"    
                                    v-bind:Multiple="false"                                
                                    :Input="ChangeDropDownAction"
                                />
                            </b-col>
                            <b-col md="3" lg="3" sm="12">
                                <MdSelect
                                    v-bind:Label="$t('Medication.RouteN')"
                                    v-bind:Options="RouteNameList"
                                    v-bind:FieldDescription="'description'"
                                    v-bind:FieldCode="'code'"
                                    v-bind:Model="ModelRoute"    
                                    v-bind:Multiple="false"                                
                                    :Input="ChangeDropDownRouteName"
                                />
                            </b-col>
                            <b-col md="3" lg="3" sm="12">
                                <MdSelect
                                    v-bind:Label="$t('Medication.When')"
                                    v-bind:Options="WhenList"
                                    v-bind:FieldDescription="'description'"
                                    v-bind:FieldCode="'code'"
                                    v-bind:Model="ModelWhen"    
                                    v-bind:Multiple="false"                                
                                    :Input="ChangeDropDownWhen"
                                />
                            </b-col>
                            <b-col md="3" lg="3" sm="12">
                                <MdSelect
                                    v-bind:Label="$t('Shared.Reason')"
                                    v-bind:Options="ReasonList"
                                    v-bind:FieldDescription="'description'"
                                    v-bind:FieldCode="'code'"
                                    v-bind:Model="ModelReason"    
                                    v-bind:Multiple="false"                                
                                    :Input="ChangeDropDownReason"
                                />
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col md="12" lg="12">
                                <MdMemo
                                    v-bind:Name="`textarea_notes_${index}`"
                                    v-bind:Rows="'3'"
                                    v-bind:MaxRows="'6'"
                                    v-bind:MaxLength="'500'"
                                    v-model="value.sig"
                                />                                     
                            </b-col>
                        </b-row>

                        <MdTitle v-bind:Text="$t('Shared.PrescriberNotes')" v-bind:isSubtitle="true" v-bind:Name="'T_TitleSearch'"/>
                        <b-row>
                            <b-col md="12" lg="12">
                                <MdMemo
                                    v-bind:Name="`prescriberNotes_${index}`"
                                    v-bind:Rows="'3'"
                                    v-bind:MaxRows="'6'"
                                    v-bind:MaxLength="'500'"
                                    v-model="value.notes"
                                />                                     
                            </b-col>
                        </b-row>
                    </div>
                </div>
            </div>
        </div>

        <ModalDosageTime
            v-bind:marsTimes="marsTimes"
            v-bind:ReadOnly="false"
            v-bind:unitOfMeasure="unitOfMeasure"
            v-bind:DailyAmount="value.qtytoTake"
            @OnModalDosageTimeCancel="HideModalDosageTime"
            @RefreshDosageTime="RefreshDosageTime"
            @DosageDifferent="DosageDifferent"
            v-if="VisibleDosageTime"
            v-bind:ModalId="'modalIdDosageTime'"
            v-bind:TitleWindow="$t('Medication.TitleModalDosageTime')"        
        />
    </b-card-body>
</template>

<script>
import ShowMessage from '@/components/messages/ShowMessage.js'
import DBFunctions from '@/common/DBFunctions.js'
import Permission from '@/common/Permission'
import MarsService from '@/services/mars.service'
import MedicationService from '@/services/medication.service'
import Utils from "@/common/utils"

export default {
    mixins: [ShowMessage, DBFunctions, Permission],  
    name: 'DrugProtocolSetup',

    props: {
        value: Object,
        index: Number,
        ActionList: Array,
        RouteNameList: Array,
        WhenList: Array,
        ReasonList: Array,
        PharmacyOption: Object
    },

    data() {
        return {
            isDayValid:true,
            isDosageValid:true,
            isDailyAmountValid:true,
            isFrequencyValid:true,
            isTitrationOrderValid:true,
            VisibleDosageTime:false,
            listCopyImages:[],
            images:[],
            marsTimes:[],
            FrequencyAuxFields:['hoursBetweenDoses','mode','recurEveryDays','timesPerDay'],
            TextFrequency:this.$t('Msg.RequiredField'),
            BaseFields:[
                { key: 'description', sortable: true, label: this.$t('Shared.Description')},
                { key: 'code', sortable: true, label: this.$t('Shared.Code')},
                { key: 'mode', sortable: true, label: this.$t('Shared.Mode')},
                { key: 'recurEveryDays', sortable: true, label: this.$t('Shared.ReEveryDays')},
                { key: 'timesPerDay', sortable: true, label: this.$t('Shared.TimesPerDay')},
                { key: 'hoursBetweenDoses', sortable: true, label: this.$t('Shared.HoursBetweenDoses')},
            ],
            ModelAction:{code:"",description:""},
            ModelRoute:{code:"",description:""},
            ModelWhen:{code:"",description:""},
            ModelReason:{code:"",description:""},
            ModelUsage:{value:"",name:""},
            MarsAdminTime:[],
            MarsDosage:[],
            timesPerDay:0,
            frecuencyMode:'',
            pendingChanges:false,
        }
    },

    computed: {
        unitOfMeasure() {
            return `(${this.value.unit})`;
        }
    },

    methods: {
        async ImageDrugName(){      
            this.images = [];

            if(!this.ContainImageUrl(this.value.drugCode)){
                this.Load = true;
                await MarsService.getImageByDrug(this.value.drugCode)
                            .then((response) => {
                                if(response.status == '200'){                          
                                    this.images = response.data.images;
                                    if(!this.ContainImageUrl(this.value.drugCode)){
                                        this.listCopyImages.push({Code:this.value.drugCode,images:this.images});
                                    }
                                }  
                                this.Load = false;                           
                            })
                            .catch((error) => {
                                this.Load = false; 
                                this.showResponseErrorMessage(error);  
                            });
            } else {
                this.images = this.getListImageinCopy(this.value.drugCode);
            }
        },

        async getMarsTimes() {          
            await MedicationService
                .getMarsTimes(this.value.frequency,this.value.doseQty,this.value.qtytoTake)
                .then((response) => {      
                    if (response.data) {              
                        let marsList = response.data;

                        if(marsList.length > 0){  
                            let arr = [];                  
                            marsList.forEach((item) => {                       
                                arr.push({
                                    adminTime: Utils.formatTimeHm(item.adminTime),
                                    dosage: item.dosage                                                           
                                });                                    
                            });

                            this.marsTimes = arr;
                            this.value.marsTimes = [...marsList];
                        }
                    }                     
                })
                .catch(error => {
                    this.showResponseErrorMessage(error);                   
                }); 
        },

        getMedSig() {
            this.SeparateList();       
            let params = {
                DrugCode:this.value.drugCode,
                FreqCode:this.value.frequency,
                Day:this.value.day,
                Dosage:this.value.doseQty,
                DailyAmount:this.value.qtytoTake,
                Action:this.ModelAction.code,
                Route:this.ModelRoute.code,
                WhenSig:this.ModelWhen.code,
                Reason:this.ModelReason.code,
                MarsAdminTime:this.MarsAdminTime,
                MarsDosage:this.MarsDosage,
            }
            MedicationService
                .getSig(params)
                .then((response) => {      
                    if (response.data) {                   
                        const data = response.data;
                        if (Object.prototype.hasOwnProperty.call(data, 'sig')) {
                            this.value.sig = data.sig;
                        } else {
                            this.value.sig  = JSON.stringify(data);
                        }
                        
                        this.$emit('input', this.value);
                    }  
                })
                .catch(error => {
                    this.showResponseErrorMessage(error);
                }); 
        },

        getMedQuantityToOrder() {
            this.SeparateList();
            let params = {
                DrugCode:this.value.drugCode,
                FreqCode:this.value.frequency,
                DailyAmount:this.value.qtytoTake,
                SDTime:'00:00:00',
                EDTime:'23:59:59',
                Day:this.value.day,
                MarsAdminTime:this.MarsAdminTime,   
                MarsDosage:this.MarsDosage,   
            }    
            MedicationService
                .getQuantityToOrder(params)
                .then((response) => {      
                    if (response.status === 200) {                   
                        this.value.quantityOrdered  = response.data;
                        this.$emit('input', this.value);
                    }
                })
                .catch(error => {
                    this.showResponseErrorMessage(error);
                });
        },

        async getMedDrugFrequencyByCode(fCode) {
            await MedicationService
                .getDrugFrequencyByCode(fCode)
                .then((response) => {      
                    if (response.data) {             
                        this.timesPerDay = response.data.timesPerDay;
                    }
                })
                .catch(error => {
                    this.showResponseErrorMessage(error);
                }); 
        },

        SeparateList(){
            this.MarsAdminTime = [];
            this.MarsDosage = [];
            for(var i = 0; i < this.value.marsTimes.length; i++ ){
                this.MarsAdminTime.push(this.value.marsTimes[i].adminTime);
                this.MarsDosage.push(this.value.marsTimes[i].dosage);
            }
        },

        ContainImageUrl(Code){
            for(var i = 0; i < this.listCopyImages.length; i++){
                if(this.listCopyImages[i].Code === Code){
                    return true;
                }
            }
            return false;
        },

        getListImageinCopy(Code){
            for(var i = 0; i < this.listCopyImages.length; i++){
                if(this.listCopyImages[i].Code === Code){
                    return this.listCopyImages[i].images;
                }
            }
            return [];
        },

        OnBlurDay(item){
            if (item <= 0){
                this.value.day = 1;
                this.$emit('input', this.value);
            }
        },

        onChangeDay(item){  
            if (item <= 0){
                this.value.day = 1;
                this.$emit('input', this.value);
            }       
            
            this.getMedSig();
            this.getMedQuantityToOrder();     
        },

        async onChangeDosage() {
            this.getMedSig();
            if(this.value.frequency !== null && this.value.frequency !== ""){
                await this.getMedDrugFrequencyByCode(this.value.frequency);   
                this.value.qtytoTake = this.value.doseQty * this.timesPerDay; 
            }else{
                this.value.qtytoTake = 0;
            }

            this.$emit('input', this.value);
            await this.getMarsTimes();
            this.getMedQuantityToOrder();         
        },

        async onChangeDailyAmount(){           
            this.getMedSig();
            if(this.value.frequency !== null && this.value.frequency !== ""){
                await this.getMedDrugFrequencyByCode(this.value.frequency);
                this.value.doseQty = this.value.qtytoTake / this.timesPerDay;            
            }else{
                this.value.doseQty = 0;
            }

            this.$emit('input', this.value);
            await this.getMarsTimes();   
            this.getMedQuantityToOrder();           
        },

        OpenDosageTime(){
            this.VisibleDosageTime = true;
        },

        onChangePatientOwned(){

        },

        async onCodeConditionOk(result){
            var type = result.FieldName;                  
            if(type.indexOf('Frequency')  >= 0 ){
                switch (type) {               
                default:
                    if(result.code){
                        this.frecuencyMode = result.AuxFields[1]
                        let fCode = result.code.trim(); 
                        if (result.code.trim() !== this.value.frequency){                  
                            if(fCode !== null && fCode !== ""){
                                await this.getMedDrugFrequencyByCode(fCode);
                                
                                if(this.value.qtytoTake > 0 && this.value.doseQty === 0){
                                    this.value.doseQty = this.value.qtytoTake / this.timesPerDay;
                                }

                                this.value.qtytoTake = this.value.doseQty * this.timesPerDay; 
                            }
                        }  

                        this.value.frequency = result.code.trim();
                        this.value.frequencyDescription = result.description.trim();
                        this.value.mode = result.AuxFields[1] ? result.AuxFields[1] : '';
                        
                        if (result.AuxFields[1] && result.AuxFields[1] === 'TIMED') {
                            await this.getMarsTimes();
                            this.getMedQuantityToOrder(); 
                            this.getMedSig();
                        } else if(result.AuxFields[1] && result.AuxFields[1] === 'STAT') {
                            this.marsTimes = [];
                            this.value.marsTimes = [];
                            this.value.day = 1;
                            this.onChangeDay(1);
                        } else {       
                            this.marsTimes = [];
                            this.value.marsTimes = [];
                            this.getMedQuantityToOrder(); 
                            this.getMedSig();
                        }
                    } else {
                        this.value.frequency = "";
                        this.value.frequencyDescription = "";
                        this.value.mode = "";
                    }

                    this.$emit('input', this.value);
                }
            }
        },

        ChangeDropDownUsage(item){
            if(item !== null){
                this.value.usage = item.value;
            }else{
                this.value.usage = "";
            }

            this.$emit('input', this.value);
        },

        ChangeDropDownAction(item){
            if(item !== null){
                this.ModelAction = item;
                this.value.action = item.code;           
                this.getMedSig();
            }else{
                this.ModelAction = {code:"",description:""};
                this.value.action = "";
            }
            
            this.$emit('input', this.value);
        },

        ChangeDropDownRouteName(item){
            if(item !== null){
                this.ModelRoute = item;
                this.value.route = item.code;
                this.getMedSig();
            }else{
                this.ModelRoute = {code:"",description:""};
                this.value.route = "";
            }
            
            this.$emit('input', this.value);
        },

        ChangeDropDownWhen(item){
            if(item !== null){
                this.ModelWhen = item;
                this.value.whenSig = item.code;
                this.getMedSig();
            }else{
                this.ModelWhen = {code:"",description:""};
                this.value.whenSig = "";
            }
            
            this.$emit('input', this.value);
        },

        ChangeDropDownReason(item){
            if(item !== null){
                this.ModelReason = item;
                this.value.reason = item.code;
                this.getMedSig();
            }else{
                this.ModelReason = {code:"",description:""};
                this.value.reason = "";
            }

            this.$emit('input', this.value);
        },

        HideModalDosageTime(){
            this.VisibleDosageTime = false;
        },

        async RefreshDosageTime(obj){
            this.value.marsTimes = obj.marsTimes;
            this.VisibleDosageTime = false;
        },

        DosageDifferent(i){
            this.value.doseQty = i ? 0 : this.value.doseQty;
            this.$emit('input', this.value);
        },

        ValidateRequired(){
            this.isFrequencyValid = Utils.isNullOrEmptyString(this.value.frequency) ? false : true;
            this.isDayValid = this.value.day <= 0 ? false : true;
            this.isDosageValid = this.value.doseQty <= 0 ? false : true;
            this.isDailyAmountValid = this.value.qtytoTake <= 0 ? false : true;
            this.isTitrationOrderValid = this.value.titrationOrder <= 0 ? false : true;
            
            this.TextFrequency = this.value.frequency === "" ? this.$t('Msg.RequiredField') : this.$t('Medication.InvalidFrequency');
            
            const result = this.isFrequencyValid && this.isDayValid &&
                    this.isDosageValid && this.isDailyAmountValid && 
                    this.isTitrationOrderValid;
            this.value.isValidateRequired = result;
            this.value.errorMessage = null;
            this.$emit('input', this.value);
            return result;
        },

        PrepareMedication (){
            return {
                DrugCode:this.value.drugCode,
                DrugName:this.value.drugName,
                Usage:this.value.usage,
                Day:this.value.day,
                DoseQty:this.value.doseQty,
                QtytoTake:this.value.qtytoTake,
                QuantityOrdered:this.value.quantityOrdered,
                Frequency:this.value.frequency,
                Sig:this.value.sig,
                Action:this.ModelAction.code,
                Route:this.ModelRoute.code,
                WhenSig:this.ModelWhen.code,
                Reason:this.ModelReason.code,
                Notes:this.value.notes,
                Form:this.value.form,
                TitrationOrder:this.value.titrationOrder,
                StandingOrderMarsTimes:this.value.marsTimes.map(x => ({
                    adminTime: x.adminTime,
                    qty: x.dosage,
                    recNo: x.recNo,
                    recordId: x.recordId
                })),
                Mode:this.value.mode,
                Unit:this.value.unit,
                IsReusable:this.value.isReusable,
                DispensingCapacity:this.value.DispensingCapacity,
                RecordId:this.value.recordId
            }
        },

        initialize() {
            if (this.value) {
                if (!Utils.isNullOrEmptyString(this.value.action)) {
                    const action = this.ActionList.find(x => x.code.toUpperCase() == this.value.action.toUpperCase());
                    if (action) {
                        this.ModelAction.code = action.code;
                        this.ModelAction.description = action.description;
                    }
                }

                if (!Utils.isNullOrEmptyString(this.value.routeName)) {
                    const route = this.RouteNameList.find(x => x.code.toUpperCase() == this.value.routeName.toUpperCase());
                    if (route) {
                        this.ModelRoute.code = route.code;
                        this.ModelRoute.description = route.description;
                    }
                }
                
                if (!Utils.isNullOrEmptyString(this.value.whenSig)) {
                    const whenSign = this.WhenList.find(x => x.code.toUpperCase() == this.value.whenSig.toUpperCase());
                    if (whenSign) {
                        this.ModelWhen.code = whenSign.code;
                        this.ModelWhen.description = whenSign.description;
                    }
                }

                if (!Utils.isNullOrEmptyString(this.value.reason)) {
                    const reason = this.ReasonList.find(x => x.code.toUpperCase() == this.value.reason.toUpperCase());
                    if (reason) {
                        this.ModelReason.code = reason.code;
                        this.ModelReason.description = reason.description;
                    }
                }

                this.frecuencyMode = this.value.mode;

                const marsList = [ ...(this.value.marsTimes ?? [])];
                if(marsList.length > 0){  
                    let arr = [];                  
                    marsList.forEach((item) => {                       
                        arr.push({
                            adminTime: Utils.formatTimeHm(item.adminTime),
                            dosage: item.dosage                                                           
                        });                                    
                    });

                    this.marsTimes = arr;
                    this.value.marsTimes = [...marsList];
                } else {
                    this.marsTimes = [];
                    this.value.marsTimes = [];
                }
            }
        },

        setPendingChanges(value) {
            this.pendingChanges = value;
        },

        getPendingChanges() {
            return this.pendingChanges;
        },
    },

    mounted() {
        this.initialize();
    }
}
</script>

<style scoped>
.patPhoto {
    position: relative;
    display: inline-block;
    overflow: hidden;
    padding-bottom: 10px;
    transition: transform 0.3s ease-in-out;
}

.patPhoto img {
    display: block;
    width: 100%;
    height: auto;
    border: 3px solid white;
    border-radius: 10px;
    object-fit: cover;
    box-shadow: 0 3px 3px rgba(0, 0, 0, 0.1);
    transition: all 0.3s ease-in-out;
}

.patPhoto:hover {
    transform: scale(1.2);
}
.patPhoto:hover img{
    box-shadow: 5px 5px 10px rgba(0, 0, 0, 0.05);
}

.patPhoto::after {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: linear-gradient(to right, rgba(255, 255, 255, 0), rgba(255, 255, 255, 0.5), rgba(255, 255, 255, 0));
    transform: translateY(100%);
    transition: transform 0.5s ease-in-out;
}

.patPhoto:hover::after {
    transform: translateY(-100%);
}

.no-image {
    text-align: center;
    font-size: 18px;
    color: #ffffff;
}

.carouselPic{
    background-color: #FFF !important;
    border-radius: 15px 15px 0 0;
    border: 4px solid #19BEE1;
    overflow: hidden;
}
.carouselPic .carousel-item{
    background-color: #FFF !important;
}
.patPhoto .carousel-description{
    color: white !important;
    background-color: #19BEE1;
    border-radius: 0 0 15px 15px;
    height: 40px;
}
.patPhoto .carousel-description p{
    display: flex;
    align-items: center;
    justify-content: center;
    height: 40px;
    line-height: 1;
    font-size: small;
    padding: 2px 10px 2px 10px;
}
.relocateIcon{
    position: absolute;
    top: 5px;
    right: 20px;
}
.relocateIconMed{
    position: absolute;
    top: 5px;
    right: 25px;
}
</style>